<template>
  <div id="company_info" class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>新建領款單</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <h4 class="col-md-1">日期:</h4>
      <div class="col-md-3">
        <input
          type="date"
          class="inputstyle fontSize16"
          v-model="actualWithdrawalDate"
        />
      </div>
      <h4 class="col-md-1">司機名稱:</h4>
      <div class="col-md-3">
        <input
          v-model="kw"
          type="text"
          required="required"
          class="inputstyle col-md-8 fontSize16"
          placeholder="隊編、姓名、電話"
          style="margin-right: 5px"
        />
        <button type="button" @click="searchKeyWord" class="btn btn-success">
          搜尋
        </button>
      </div>
      <div class="col-md-2">
        <select
          class="form-control"
          required=""
          v-model="driverId"
          @change="searchDriverSigning"
        >
          <option :value="0">選擇</option>
          <option v-for="driver in driverList" :value="driver.id">
            {{ driver.name }}-{{ driver.callNumber }}
          </option>
        </select>
      </div>
    </div>
    <hr />
    <el-row>
      <el-col :span="8">
        <FilterOption
          :options="options"
          @selectFilter="selectFilter"
        ></FilterOption>
      </el-col>
      <el-col :span="8">
        <FilterTag ref="filterTag" @searchList="searchList"></FilterTag>
      </el-col>
    </el-row>
    <hr />

    <div class="row">
      <template>
        <el-table
          :header-cell-style="tableHeaderColor"
          :data="nonInInvoiceOfSigninglist"
          style="width: 100%"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            prop="companyName"
            label="公司名稱"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="createdAt"
            label="訂單時間"
            width="180"
          ></el-table-column>
          <el-table-column label="司機編號-姓名">
            <template slot-scope="scope">
              {{ scope.row.callNumber }}-{{ scope.row.driverName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="employeeNameJobNumber"
            label="工號-員工姓名"
          ></el-table-column>
          <el-table-column prop="onAddress" label="上車地點"></el-table-column>
          <el-table-column prop="offAddress" label="下車地點"></el-table-column>
          <el-table-column prop="type" label="訂單種類"></el-table-column>
          <el-table-column
            prop="actualFare"
            label="司機填入金額"
          ></el-table-column>
          <el-table-column
            prop="signingNote"
            label="簽單備註"
          ></el-table-column>
          <el-table-column label="簽名檔">
            <template slot-scope="scope">
              <template v-for="item in scope.row.employeePhoto">
                <img width="120" height="100" :src="item.photo" />
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="driverReceivePaymentDate"
            label="司機可請款日期"
          ></el-table-column>
          <el-table-column label="放入領款單">
            <template slot-scope="scope">
              <input
                type="checkbox"
                class="flat"
                style="zoom: 180%"
                :disabled="withdrawalItems.length !== 0"
                v-model="scope.row.isPayment"
                :checked="scope.row.isPayment"
                @click="addEnterpriseInWithdrawal(scope.$index)"
              />
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <el-row :gutter="20">
      <el-col :span="6" :offset="18">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="nextPage"
          :page-count="totalPage"
          :current-page="page"
        ></el-pagination>
      </el-col>
    </el-row>
    <hr />
    <div class="row">
      <div class="col-md-2 fontSize20">
        統計: {{ fee.expired + fee.nonExpired }}元
      </div>
      <div class="col-md-2 fontSize20">
        到期:
        <span style="color: #f5425a">{{ fee.expired }}元</span>
      </div>
      <div class="col-md-2 fontSize20">
        未到期:
        <span style="color: #f5425a">{{ fee.nonExpired }}元</span>
      </div>
      <div class="col-md-3 fontSize20">
        (未分配餘額:
        <span style="color: #f5425a">{{ remainder }}元</span>
        )
      </div>
    </div>
    <hr />
    <div class="row">
      <button class="btn btn-primary fontSize18" @click="addFareItem">
        +費用
      </button>
    </div>
    <template v-for="(item, index) in withdrawalItems">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div
              class="card-body"
              style="
                border-style: solid;
                border-color: #c4c4c4;
                margin-bottom: 5px;
              "
            >
              <div class="row" style="margin: 10px 0">
                <div class="col-md-2">
                  <select
                    class="form-control"
                    v-model="item.itemId"
                    @change="calculateProgramFee(index)"
                  >
                    <option :value="0">未選擇</option>
                    <option
                      v-for="item in teamdDefaultWithdrawalItems"
                      :value="item.id"
                    >
                      {{ item.name
                      }}{{
                        item.expiredProcessingFee !== 0
                          ? `(${
                              item.expiredProcessingFee !== 0
                                ? item.expiredProcessingFee
                                : 0
                            }%,`
                          : '(0,'
                      }}{{
                        item.nonExpiredProcessingFee !== 0
                          ? `${item.nonExpiredProcessingFee}%)`
                          : '0)'
                      }}
                    </option>
                  </select>
                </div>
                <div class="col-md-2">
                  <el-select v-model="item.condition" placeholder="請選擇">
                    <el-option
                      v-for="item in conditions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-md-8">
                  <h4 class="col-md-1">金額:</h4>
                  <input
                    type="number"
                    required="required"
                    class="inputstyle fontSize16 col-md-1 input-interval"
                    placeholder="金額"
                    @input="inputFunc(index, $event)"
                    v-model="item.initalFee"
                  />
                  <h4 class="col-md-1">手續費:</h4>
                  <input
                    type="text"
                    required="required"
                    class="inputstyle fontSize16 col-md-1 input-interval"
                    placeholder="手續費"
                    v-model="item.serviceFee"
                    disabled
                  />
                  <h4 class="col-md-2">實際金額:</h4>
                  <input
                    type="text"
                    required="required"
                    class="inputstyle fontSize16 col-md-1 input-interval"
                    placeholder="實際金額"
                    v-model="item.actualFee"
                    disabled
                  />
                  <h4 class="col-md-1">備註:</h4>
                  <input
                    type="text"
                    required="required"
                    class="inputstyle fontSize16 col-md-3 input-interval"
                    placeholder="備註"
                    v-model="item.note"
                  />
                </div>
                <div class="pull-right">
                  <button
                    class="btn btn-danger"
                    v-show="withdrawalItems.length === index + 1"
                    @click="removeTeamWithdrawalItem(index)"
                  >
                    移除
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <hr />
    <div class="row">
      <div class="col-md-1 fontSize16">領款單備註:</div>
      <input
        type="text"
        required="required"
        class="inputstyle fontSize16 col-md-4"
        placeholder="領款單備註"
        v-model="withdrawalNote"
      />
      <button
        class="pull-right btn btn-primary fontSize20"
        @click="createDriverWithdrawal"
      >
        +新增領款單
      </button>
    </div>
  </div>
</template>
<script>
import SigningListInWithdrawalModal from '@/components/company/SigningListInWithdrawalModal'
import API from '@/assets/js/libs/API'
import EnterpriseAPI from '@/assets/js/libs/EnterpriseAPI'
import { Notification, MessageBox } from 'element-ui'
import dayjs from 'dayjs'
import FilterOption from '@/components/element_ui/filter_componet/Filter'
import FilterTag from '@/components/element_ui/filter_componet/Tag'

export default {
  components: {
    SigningListInWithdrawalModal,
    FilterOption,
    FilterTag,
  },
  data() {
    return {
      driverList: [],
      nonInInvoiceOfSigninglist: [],
      signingList: [],
      optSigningDetailList: [],
      teamdDefaultWithdrawalItems: [],
      withdrawalItems: [],
      kw: '',
      driverId: 0,
      isChangePage: false,
      isAddInvoice: [],
      isAddEnterprise: [],
      withdrawalNote: '',
      actualWithdrawalDate: null,
      totalFee: 0,
      type: 'companyName',
      fee: {
        nonExpired: 0,
        expired: 0,
      },
      paymentfee: {
        nonExpired: 0,
        expired: 0,
      },
      page: 1,
      npp: 10,
      totalPage: 1,
      filter: '',
      optSigningAndInvoice: [],
      optNonInInvoiceSigning: [],
      options: [],
      conditions: [
        {
          label: '到期',
          value: 0,
        },
        {
          label: '未到期',
          value: 1,
        },
      ],
    }
  },
  computed: {
    remainder() {
      return this.fee.nonExpired + this.fee.expired - this.totalFee
    },
  },
  mounted() {
    this.getTeamDefaultWithdrawalItem()
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #445465;color: #fff;font-weight: 500;'
      }
    },
    searchList(val) {
      this.nonInInvoiceOfSigninglist = []
      this.filter = ''
      console.log(val)
      for (let i = 0; i < val.length; i++) {
        this.filter = this.filter + `&${val[i].key}=${val[i].value}`
      }
      this.searchDriverSigning()
    },
    selectFilter(val) {
      this.$refs.filterTag.setTag(val)
    },
    nextPage(page) {
      this.page = page
      this.isChangePage = true
      this.searchDriverSigning()
    },
    optWithdrawalProgram(index) {
      this.calculateProgramFee(index)
    },
    withdrawalDriver() {
      EnterpriseAPI.post(`enterprise/withdrawal/driver`, {
        driverId: this.driverId,
        actualWithdrawalDate: this.actualWithdrawalDate,
        signingList: this.isAddEnterprise.reduce((acc, { id }) => {
          if (acc === '') {
            return id.toString()
          } else {
            return acc + ',' + id.toString()
          }
        }, ''),
        feeList: JSON.stringify(this.withdrawalItems),
        note: this.withdrawalNote,
      })
        .then((result) => {
          if (result.success) {
            Notification({
              message: result.result,
              type: 'success',
            })
            this.$router.replace({ name: 'companyList' })
          } else {
            Notification({
              message: '建立請款單發生錯誤',
              type: 'error',
            })
            console.error(result.result)
          }
        })
        .catch((e) => {
          Notification({
            message: '網路連線不穩定，請再操作一次，' + e,
            type: 'error',
          })
          console.error(e)
        })
    },
    createDriverWithdrawal() {
      if (this.driverId === 0) {
        return Notification({
          message: `請選擇司機`,
          type: 'warning',
        })
      }
      if (this.actualWithdrawalDate === null) {
        return Notification({
          message: `請選擇日期`,
          type: 'warning',
        })
      }
      if (this.isAddEnterprise.length === 0) {
        return Notification({
          message: `尚未勾選簽單`,
          type: 'warning',
        })
      }
      if (this.remainder > 0) {
        MessageBox.confirm('目前餘額不為零，確定要產生領款單嗎?', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => this.withdrawalDriver())
          .catch(() => {
            Notification({
              message: '取消產生領款單',
              type: 'info',
            })
          })
      } else {
        this.withdrawalDriver()
      }
    },
    getTeamDefaultWithdrawalItem() {
      EnterpriseAPI.get(`enterprise/withdrawal/teamItem`)
        .then((res) => {
          this.teamdDefaultWithdrawalItems = res.result.list
        })
        .catch((err) => {
          this.$msg('網路連線異常')
        })
    },
    addFareItem() {
      if (this.withdrawalItems.length === 0) {
        this.withdrawalItems.push({
          itemId: 0,
          initalFee: 0,
          actualFee: 0,
          serviceFee: 0,
          note: '',
          condition: '',
        })
        return
      }

      if (
        this.withdrawalItems[this.withdrawalItems.length - 1].condition === 0
      ) {
        this.paymentfee.expired =
          this.paymentfee.expired -
          this.withdrawalItems[this.withdrawalItems.length - 1].initalFee
      } else if (
        this.withdrawalItems[this.withdrawalItems.length - 1].condition === 1
      ) {
        this.paymentfee.nonExpired =
          this.paymentfee.nonExpired -
          this.withdrawalItems[this.withdrawalItems.length - 1].initalFee
      }
      this.withdrawalItems.push({
        itemId: 0,
        initalFee: 0,
        actualFee: 0,
        serviceFee: 0,
        note: '',
        condition: '',
      })
    },
    inputFunc(index, event) {
      if (this.withdrawalItems[index].condition === '')
        return alert('選擇到期/未到期項目')
      if (this.withdrawalItems[index].itemId === 0) return alert('選擇費用項目')
      if (event.target.value === '') return
      if (this.withdrawalItems[index].condition === 0) {
        let fee = parseInt(event.target.value)
        if (fee > this.paymentfee.expired) {
          this.withdrawalItems[index].initalFee = 0
          return alert('輸入到期費用超過')
        }
        this.withdrawalItems[index].initalFee = fee
        this.calculateProgramExpiredFee(index)
        this.calculateTotalFee()
        return
      }

      if (this.withdrawalItems[index].condition === 1) {
        let nonfee = parseInt(event.target.value)
        if (nonfee > this.paymentfee.nonExpired) {
          this.withdrawalItems[index].initalFee = 0
          return alert('輸入未到期費用超過')
        }
        this.withdrawalItems[index].initalFee = nonfee
        this.calculateProgramFee(index)
        this.calculateTotalFee()
        return
      }
    },
    calculateProgramFee(index) {
      let teamWithdrawalIndex = this.teamdDefaultWithdrawalItems
        .map((element) => element.id)
        .indexOf(this.withdrawalItems[index].itemId)
      this.withdrawalItems[index].serviceFee = Math.ceil(
        (this.withdrawalItems[index].initalFee *
          parseInt(
            this.teamdDefaultWithdrawalItems[teamWithdrawalIndex]
              .nonExpiredProcessingFee,
          )) /
          100,
      )
      this.withdrawalItems[index].actualFee = Math.round(
        this.withdrawalItems[index].initalFee -
          this.withdrawalItems[index].serviceFee,
      )
    },
    calculateProgramExpiredFee(index) {
      let teamWithdrawalIndex = this.teamdDefaultWithdrawalItems
        .map((element) => element.id)
        .indexOf(this.withdrawalItems[index].itemId)
      this.withdrawalItems[index].serviceFee = Math.ceil(
        (this.withdrawalItems[index].initalFee *
          parseInt(
            this.teamdDefaultWithdrawalItems[teamWithdrawalIndex]
              .expiredProcessingFee,
          )) /
          100,
      )
      this.withdrawalItems[index].actualFee = Math.round(
        this.withdrawalItems[index].initalFee -
          this.withdrawalItems[index].serviceFee,
      )
    },
    calculateTotalFee() {
      this.totalFee = 0
      for (let i = 0; i < this.withdrawalItems.length; i++) {
        this.totalFee = this.totalFee + this.withdrawalItems[i].initalFee
      }
    },
    removeTeamWithdrawalItem(index) {
      console.log(this.withdrawalItems[index])
      this.totalFee = this.totalFee - this.withdrawalItems[index].initalFee
      if (this.withdrawalItems[index].condition === 0) {
        this.paymentfee.expired =
          this.paymentfee.expired + this.withdrawalItems[index].initalFee
      } else if (this.withdrawalItems[index].condition === 1) {
        this.paymentfee.nonExpired =
          this.paymentfee.nonExpired + this.withdrawalItems[index].initalFee
      }
      this.withdrawalItems.splice(index, 1)
    },
    addEnterpriseInWithdrawal(index) {
      this.nonInInvoiceOfSigninglist[index].isPayment =
        !this.nonInInvoiceOfSigninglist[index].isPayment
      if (this.nonInInvoiceOfSigninglist[index].isPayment) {
        this.isAddEnterprise.push({
          id: this.nonInInvoiceOfSigninglist[index].id,
          singingList: this.nonInInvoiceOfSigninglist[index],
        })
      } else {
        let invoiceIndex = this.isAddEnterprise
          .map((item) => item.id)
          .indexOf(this.nonInInvoiceOfSigninglist[index].id)
        if (invoiceIndex > -1) {
          this.isAddEnterprise.splice(invoiceIndex, 1)
        }
      }
      this.calculateFee()
    },
    searchKeyWord() {
      API.get(`driver-v2/list?task=search&kw=${this.kw}`)
        .then((res) => {
          this.driverList = res.result.driverList
        })
        .catch((err) => {
          this.$msg('網路連線異常')
        })
    },
    searchDriverSigning() {
      if (this.driverId !== 0) {
        /* 確認是否為點擊換頁的情況 */
        if (!this.isChangePage) {
          this.page = 1
          this.isAddEnterprise = []
          this.calculateFee()
        }
        this.isChangePage = false
        const url = `enterprise/signingList/v2?page=${this.page}&npp=${this.npp}${this.filter}&driver_id=${this.driverId}&is_payment=false`
        EnterpriseAPI.get(url)
          .then((res) => {
            if (!res.success) throw new RangeError(res.result)
            const { count, list } = res.result
            this.nonInInvoiceOfSigninglist = this.sortSigningaymentStatus(
              list,
            ).map((order) => {
              return {
                ...order,
                createdAt: dayjs(order.createdAt).format('YYYY-MM-DD HH:mm'),
              }
            })
            this.totalPage = Math.ceil(count / this.npp)
            this.sortSigningList('companyName')
          })
          .catch((e) => {
            this.count = 0
            this.signing = []
            this.totalPage = 0
            this.$msg(e.message)
          })
      } else {
        return this.$msg('請選擇司機')
      }
    },
    sortSigningaymentStatus(list) {
      const id = this.isAddEnterprise.map((element) => {
        return element.id
      })
      for (let i = 0; i < list.length; i++) {
        if (id.indexOf(list[i].id) !== -1) list[i].isPayment = true
      }
      return list
    },
    calculateFee() {
      this.fee.nonExpired = 0
      this.fee.expired = 0
      this.paymentfee.nonExpired = 0
      this.paymentfee.expired = 0
      for (let i = 0; i < this.isAddEnterprise.length; i++) {
        if (
          this.checkDateExpired(
            this.isAddEnterprise[i].singingList.driverReceivePaymentDate,
          )
        ) {
          this.fee.expired =
            this.fee.expired + this.isAddEnterprise[i].singingList.actualFare
          this.paymentfee.expired = this.fee.expired
        } else {
          this.fee.nonExpired =
            this.fee.nonExpired + this.isAddEnterprise[i].singingList.actualFare
          this.paymentfee.nonExpired = this.fee.nonExpired
        }
      }
    },
    checkDateExpired(driverReceivePaymentDate) {
      if (driverReceivePaymentDate) {
        const current = dayjs().format('YYYY-MM-DD')
        if (
          dayjs(driverReceivePaymentDate).isBefore(current, 'day') ||
          dayjs(driverReceivePaymentDate).isSame(current, 'day')
        ) {
          return true
        }
      }
      return false
    },
    sortSigningList(type) {
      if (type === 'companyName') {
        this.nonInInvoiceOfSigninglist = this.nonInInvoiceOfSigninglist.sort(
          function (a, b) {
            return b.enterpriseId > a.enterpriseId ? -1 : 1
          },
        )
      } else {
        this.nonInInvoiceOfSigninglist = this.nonInInvoiceOfSigninglist.sort(
          function (a, b) {
            return b.createdAt > a.createdAt ? -1 : 1
          },
        )
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      }
      return ''
    },
  },
}
</script>
<style scoped>
.input-interval {
  margin-right: 5px;
}
.warning-row {
  background: oldlace;
}

.success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/pages/company/AddWithdrawal.vue